export function generateCompareQuoteStaticFields(): {
  email: string;
  identityNumber: string;
  phoneNumber: string;
} {
  const email = generateRandomEmail();
  const nric = generateRandomNRIC();
  const phoneNumber = generateRandomPhoneNumber();

  return {
    email,
    identityNumber: nric,
    phoneNumber,
  };
}

function generateRandomPhoneNumber() {
  return `81${Math.floor(100000 + Math.random() * 900000)}`;
}

function generateRandomEmail() {
  const domains = ['placeholder.com', 'test.com'];

  const localPart = generateRandomString(5);
  const domain = domains[Math.floor(Math.random() * domains.length)]; // Randomly select a domain

  return `${localPart}@${domain}`;
}

function generateRandomString(length: number) {
  const CHARACTERS = 'abcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  const charactersLength = CHARACTERS.length;
  for (let i = 0; i < length; i++) {
    result += CHARACTERS.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function generateRandomNRIC(prefix = 'S') {
  const digits = Array.from({ length: 7 }, () =>
    Math.floor(Math.random() * 10),
  ).join('');
  const checksumLetter = generateNRICChecksum(prefix + digits);

  return prefix + digits + checksumLetter;
}

function generateNRICChecksum(nric: string) {
  const weights = [2, 7, 6, 5, 4, 3, 2];
  const chars =
    nric[0] === 'S' || nric[0] === 'T' ? 'JZIHGFEDCBA' : 'XWUTRQPNMLK';

  const sum = nric
    .substring(1, 8)
    .split('')
    .reduce((acc, digit, index) => acc + Number(digit) * weights[index], 0);
  const offset = nric[0] === 'T' || nric[0] === 'G' ? 4 : 0;
  const modulo = (sum + offset) % 11;

  return chars[modulo];
}
